import styles from './Slide1.module.css';
import SlideShell from './SlideShell';

export default function Slide1({ handleNext, handlePrev, current, total, t }) {
  return (
    <SlideShell handleNext={handleNext} handlePrev={handlePrev} current={current} total={total} t={t}>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <img src="/assets/intro/welcome.jpg" alt="" className={styles.image} />
        </div>
        <div className={styles.right}>
          <div className={styles.contentWrapper}>
            <p className={styles.title}>{t("intro_welcome_to_vinni_title")}</p>
            <p className={styles.text}>{t("intro_vinni_safe_digital_experience_text")}</p>
            <div className={styles.badge}>
              <img src='/assets/intro/badge.svg' alt='' height={22} width={22} />
              <span>{t("ad_free_child_safe_environment")}</span>
            </div>
          </div>
        </div>
      </div>
    </SlideShell>
  );
}